import { isEqual } from "lodash-es"
import { ITariffDetails } from "../tariffDetails/tariffDetails.types"
import { ITariffCompared } from "./tariffCompared.types"

export class TariffCompared implements ITariffCompared {
  constructor(
    public thisMonth?: ITariffDetails,
    public nextMonth?: ITariffDetails,
  ) {}

  get hasDifferentUnitRates(): boolean {
    if (!this.nextMonth && !this.thisMonth) return false
    if (!this.nextMonth || !this.thisMonth) return true

    if (this.nextMonth.isGas) {
      return this.nextMonth.unitRate !== this.thisMonth.unitRate
    }

    return !isEqual(this.nextMonth.unitRates, this.thisMonth.unitRates)
  }
}
